import { Badge } from "@volca/ui/components/ui/badge";
import { PageTitle } from "@volca/ui/components/ui/page-components";
import { Stack } from "@volca/ui/components/ui/stack";
import { RUN_STATUS_META } from "@/profitability/constants";
import { DocumentChip } from "@/profitability/document-chip";
import { MetaList } from "@/profitability/meta-list";
import { ReportActions } from "@/profitability/report-actions";
import { RunHeadline } from "@/profitability/run-detail/run-headline";
import type { EnrichedProfitabilityRun } from "@/profitability/types";

export const RunHeader = ({
  businessId,
  run,
  onOpenChat,
}: {
  businessId: string;
  run: EnrichedProfitabilityRun;
  onOpenChat: () => void;
}) => {
  const statusMeta = RUN_STATUS_META[run.status];
  return (
    <Stack align="stretch" gap={3} className="w-full">
      <Stack
        direction="row"
        justify="between"
        align="center"
        gap={4}
        className="w-full flex-wrap gap-y-2"
      >
        <Stack align="start" gap={1} className="min-w-0">
          <Stack direction="row" align="center" gap={2} className="flex-wrap">
            <PageTitle className="min-w-0 [overflow-wrap:anywhere]">
              {run.display.period}
            </PageTitle>
            {/* A finished report needs no badge to say so. */}
            {run.status !== "completed" && (
              <Badge variant="secondary" color={statusMeta.color} size="sm">
                {statusMeta.label}
              </Badge>
            )}
          </Stack>
          <p className="text-sm text-subtle">
            <MetaList>{run.display.metadata}</MetaList>
          </p>
          {!run.interactive_available && !!run.documents?.length && (
            <Stack gap={3} className="pt-3">
              {run.documents.map((document) => (
                <DocumentChip key={document.id} document={document} />
              ))}
            </Stack>
          )}
        </Stack>
        <Stack
          direction="row"
          align="center"
          gap={6}
          className="flex-wrap gap-y-3"
        >
          <RunHeadline run={run} />
          {run.display.workbookReady && (
            <ReportActions
              chatLabel="Ask Volca"
              businessId={businessId}
              run={run}
              onOpenChat={onOpenChat}
            />
          )}
        </Stack>
      </Stack>
    </Stack>
  );
};
